import { render } from "./MobileRow.vue?vue&type=template&id=b4fa35aa"
import script from "./MobileRow.vue?vue&type=script&lang=js"
export * from "./MobileRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__